import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'id'
      },
      {
        title: 'Name',
        dataIndex: 'name'
      },
      {
        title: 'Job ID',
        dataIndex: 'job_id'
      },
      {
        title: 'Job Name',
        dataIndex: 'job_name'
      },
      {
        title: 'Employee',
        dataIndex: 'employee_name'
      },
      {
        title: 'Updated Date',
        dataIndex: 'updated_date'
      }
    ]
  }

  getData = () => {
    const { fullReport } = this.props

    return fullReport.map((item, index) => {
      item.updated_date = moment(new Date(item.updated_date)).format('YYYY-M-D')
      return item
    })
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/general/tools/ListItems.js